export default __webpack_public_path__ + "static/N0150-7c26a593c6356fd235542a0a6674d3b8.png";